import styles from './HeroBanner.module.css';

interface HeroBannerProps {
  /** Text inside the pill, e.g. "Coming soon". */
  label: string;
}

/** Decorative masthead image with a status pill anchored to its lower edge. */
export function HeroBanner({ label }: HeroBannerProps) {
  return (
    <div className={styles.banner}>
      <div className={styles.eyebrowWrap}>
        <div className={styles.eyebrow}>
          <span className={styles.dot} aria-hidden="true" />
          {label}
        </div>
      </div>
    </div>
  );
}
